import { render, staticRenderFns } from "./AdminCreateCustomerForm.vue?vue&type=template&id=8145755a&scoped=true"
import script from "./AdminCreateCustomerForm.vue?vue&type=script&lang=js"
export * from "./AdminCreateCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateCustomerForm.vue?vue&type=style&index=0&id=8145755a&prod&scoped=true&lang=css"
import style1 from "./AdminCreateCustomerForm.vue?vue&type=style&index=1&id=8145755a&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8145755a",
  null
  
)

export default component.exports